import { useState, useEffect, useRef } from "react";
import React from "react";
import axios from "axios";
import Wrapper from "../../../components/UI/Wrapper";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import images2 from "../../../images/no_image.jpg";
import mailIcon from "../../../Icons/mail.png";
import CryptoJS from "crypto-js";

const ShipmentDetail = () => {
  const [relocationId, setRelocationId] = useState("");
  const [activeDetail, setActiveDetail] = useState("shipment");
  const [successMessage, setSuccessMessage] = useState(null);
  const [leadDetailResponse, setLeadDetailResponse] = useState([]);
  const [leadOwnerResponse, setLeadOwnerResponse] = useState([]);
  const navigate = useNavigate();
  const [ticketPrice, setTicketPrice] = useState({});
  const [relocation_date1, setRelocation_date1] = useState("");
  const [originCityCodeResponse, setOriginCityCodeResponse] = useState([]);
  const [destinationCityCodeResponse, setDestinationCityCodeResponse] =
    useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [airlinePopupData, setAirlinePopupData] = useState([]);
  const [trainPopupData, setTrainPopupData] = useState([]);
  const location = useLocation();
  const [leadUpdate, setLeadUpdate] = useState([]);
  const [followup, setFollowup] = useState([]);
  const [ivrDetail, setIvrDetail] = useState([]);
  const [mailDetail, setMailDetail] = useState([]);
  const [loading, setLoading] = useState(false);
  const [petDetail, setPetDetail] = useState([]);
  const [orderDetail, setOrderDetail] = useState([]);
  // --------start of Add Lead-------------------------
  const [assignToResponse, setAssignToResponse] = useState([]);
  const [petTypeResponse, setPetTypeResponse] = useState([]);
  const [petBreedResponse, setPetBreedResponse] = useState([]);
  const [deliveryTypeResponse, setDeliveryTypeResponse] = useState([]);
  const [originCountryResponse, setOriginCountryResponse] = useState([]);
  const [destinationCountryResponse, setDestinationCountryResponse] = useState(
    []
  );
  const [originStateResponse, setOriginStateResponse] = useState([]);
  const [destinationStateResponse, setDestinationStateResponse] = useState([]);
  const [originCityResponse, setOriginCityResponse] = useState([]);
  const [destinationCityResponse, setDestinationCityResponse] = useState([]);
  const [openshipmentstageResponse, setopenshipmentstageResponse] = useState(
    []
  );
  const [closeshipmentstageResponse, setcloseshipmentstageResponse] = useState(
    []
  );
  const [executedshipmentstageResponse, setexecutedshipmentstageResponse] =
    useState([]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [subStageResponse, setSubStageResponse] = useState([]);
  const [decryptionError, setDecryptionError] = useState(false);
  const isAdmin = localStorage.getItem("isAdmin");

  const [selectedMailDetail, setSelectedMailDetail] = useState();
  //----------------------------------------------//
  const baseAPI = process.env.REACT_APP_API_URL;

  const baseImageURL = process.env.REACT_APP_IMAGE_URL;

  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [currency, setCurrency] = useState("");

  const [documentResponse, setDocumentResponse] = useState(null);
  const [documentType, setDocumentType] = useState([]);
  const fileInputRef = useRef(null);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [awb_number, setAwb_number] = useState("");
  const [relocationDate, setRelocationDate] = useState("");
  const [invoiceDate, setInvoiceDate] = useState("");
  const handleImageClick = (imageSrc) => {
    // alert(imageSrc);
    setSelectedImage(imageSrc);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };
  //----------------------------------------------//

  // --------------------add data section starts here-------------------
  // -------for relocation detail pop-up ----------------
  const [relDetail, setRelDetail] = useState({
    flight_Number: "",
    departure_Time: "",
    arrival_Terminal: "",
    elapsed_Time: "",
    aircraft_Type: "",
    number_Of_Stops: "",
  });

  const [firstItem, setFirstItem] = useState({
    relocation_id: "",

    relocation_date: "",
    first_name: "",
    last_name: "",
    email: "",
    mobile_no: "",
    subject: "",
    message: "",
    service_type: "",
    where_did_you_find_us: "",
    referral_url: "",
    job_type: "",

    relocationdetail_id: "",
    origin_country: "",
    origin_state: "",
    origin_city: "",
    origin_pin: "",
    destination_country: "",
    destination_state: "",
    destination_city: "",
    destination_pin: "",
    available_slot: "",
    mode_of_transport: "",
    origin_address: "",
    destination_address: "",
    origin_contact_person: "",
    destination_contact_person: "",
    origin_contact_no: "",
    destination_contact_no: "",
    origin_city_code: "",
    destination_city_code: "",
    delivery_type: "",
    distance: "",
    distance2: "",
    price: "",
    relocation_detail: "",

    petdetail_id: "",
    pet_name: "",
    pet_type: "",
    pet_breed: "",
    number_of_pets: "",
    pet_length: "",
    pet_width: "",
    pet_height: "",
    container_length: "",
    pet_dob: "",

    pet_age: "",
    pet_weight: "",

    pet_photo_standing: "",
    pet_photo_sitting: "",
    vaccinationbook_front: "",
    vaccinationbook_back: "",

    shipment_nextFollowUpDate: "",
    openshipmentstage: "",
    closeshipmentstage: "",
    executedstatus: "",
    remark: "",
    sub_category: "",

    gender: "",
    relocation_purpose: "",
    alternate_number: "",
    pet_gender: "",
    pet_behaviour: "",

    Quotation: "",
    Amount_In_AED: "",
    Payment_Ter: "",
    Token_Payment: "",
    Remaining_Payment: "",
    Pymt_Status: "",
    Payment_Mode: "",
    Estimate_Id: "",
    GST: "",
    amount_exc_gst: "",

    client_doc_id: "",
    document_type: "",
    remarkDoc: "",
    doc_path: "",
    doc_name: "",
  });

  const [documentsUpload, setDocumentsUpload] = useState({
    client_doc_id: "",
    relocation_id: "",
    document_type: "",
    remarkDoc: "",
    doc_path: "",
    doc_name: "",
    priority_upload: "2",
  });


  const [shipmentDetail, setshipmentDetail] = useState({
    relocation_id: "",
    shipment_nextFollowUpDate: "",
    openshipmentstage: "",
    closeshipmentstage: "",
    executedstatus: "",
    remark: "",
    sub_category: "",

  });

  function formatDateForInput(dateString) {
    const date = new Date(dateString);
    if (isNaN(date)) return ""; // invalid date fallback
    return date.toISOString().split("T")[0]; // 'yyyy-mm-dd'
  }

  function formatDateForDisplay(dateString) {
    const date = new Date(dateString);
    if (isNaN(date)) return "";
    return date.toLocaleDateString("en-GB", {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    }); // '10 Oct 2024'
  }


  const [vaccinationBookFront, setVaccinationBookFront] = useState(null);
  const [vaccinationBookBack, setVaccinationBookBack] = useState(null);
  const [petPhotosSitting, setPetPhotosSitting] = useState(null);
  const [petPhotosStanding, setPetPhotosStanding] = useState(null);

  const [sortedColumn, setSortedColumn] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc"); // Default sort order is ascending

  const sortAndToggleOrder = (column) => {
    // Determine the new sort order
    const newSortOrder =
      sortedColumn !== column || sortOrder === "desc" ? "asc" : "desc";

    let sortedData = [...documentResponse];
    // Sorting logic here (adjusted to use newSortOrder)
    if (column === "document_type") {
      sortedData.sort((a, b) => {
        // Your sorting logic...
        const valA = a[column];
        const valB = b[column];
        if (!isNaN(valA) && !isNaN(valB)) {
          // Numeric comparison
          return newSortOrder === "asc" ? valA - valB : valB - valA;
        } else {
          // Fallback to string comparison if values aren't numeric
          return newSortOrder === "asc"
            ? String(valA).localeCompare(String(valB))
            : String(valB).localeCompare(String(valA));
        }
      });
    }
    setDocumentResponse(sortedData);
    setSortedColumn(column);
    setSortOrder(newSortOrder);
  };

  function redirectToUpdateLead(Relocation_ID) {
    // Redirect to another page
    navigate("/UpdateLead", { state: { Relocation_ID: Relocation_ID } });
  }

  function decryptRelocationID(ciphertext) {
    try {
      const bytes = CryptoJS.AES.decrypt(
        decodeURIComponent(ciphertext),
        "dbbworldwidepvtltd"
      );
      setRelocationId(bytes.toString(CryptoJS.enc.Utf8));
      return bytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.error("Error decrypting Relocation_ID:", error);
      setDecryptionError(true);

      return null;
    }
  }

  function getStatusColor(statusName) {
    switch (statusName) {
      case "Untouched":
        return "orange";
      case "Open":
        return "#28A745";
      case "Closed":
        return "#DC3545";
      case "Converted":
        return "#87CEEB";
      default:
        return "white";
    }
  }

  function getPaymentColor(Pymt_Status) {
    switch (Pymt_Status) {
      case "Partial":
        return "yellow";
      case "Received":
        return "#28A745";
      case "Pending":
        return "orange";
      default:
        return "white";
    }
  }

  const [hoveredItem, setHoveredItem] = useState(null);
  const [tooltipPosition, setTooltipPosition] = useState({});

  const handleMouseEnter = (item, event) => {
    setTooltipPosition({
      top: event.clientY + 10,
      left: event.clientX + 10,
    });
    setHoveredItem(item);
  };

  const handleMouseLeave = () => {
    setHoveredItem(null);
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const encryptedRelocationID = searchParams.get("Relocation_ID");
    const Relocation_ID = decryptRelocationID(encryptedRelocationID);

    setFirstItem((prevItem) => ({
      ...prevItem,
      relocation_id: Relocation_ID,
    }));

    setshipmentDetail((prevItem) => ({
      ...prevItem,
      relocation_id: Relocation_ID,
    }));



    const storedToken = JSON.parse(localStorage.getItem("token"));
    if (baseAPI.includes("aeapi")) {
      setCurrency("INR");
    } else {
      setCurrency("AED");
    }
    if (storedToken) {
      axios
        .get(`${baseAPI}userget/GetLeadDetail?relocation_id=` + Relocation_ID, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          setLeadDetailResponse(response.data.data);
          setFirstItem(response.data.data);

          setPetDetail(response.data.data.petsDetail);
          if (response.data.data.orderdetail != null) {
            setOrderDetail(response.data.data.orderdetail[0]);
          }
          setFollowup(response.data.data.followupDetail);
          setIvrDetail(response.data.data.ivrDetail);
          setMailDetail(response.data.data.mailDetail);
          getCountry();
          getState(response.data.data.origin_country, 1);
          getState(response.data.data.destination_country, 2);
          getCity(response.data.data.origin_state, 1);
          getCity(response.data.data.destination_state, 2);
          getPetType();
          getPetBreed(response.data.data.petsDetail[0].pet_type);
          getLeadStage(1);
          getLeadStage(2);

          getEmployeeByDepartment();
          getLeadOwner(Relocation_ID);
          setVaccinationBookFront(
            `${baseImageURL}${response.data.data.petsDetail[0].vaccinationbook_front}`
          );
          setVaccinationBookBack(
            `${baseImageURL}${response.data.data.petsDetail[0].vaccinationbook_back}`
          );
          setPetPhotosSitting(
            `${baseImageURL}${response.data.data.petsDetail[0].pet_photo_standing}`
          );
          setPetPhotosStanding(
            `${baseImageURL}${response.data.data.petsDetail[0].pet_photo_sitting}`
          );

          setFirstItem((prevItem) => ({
            ...prevItem,
            pet_name: response.data.data.petsDetail[0].pet_name,
            pet_behaviour: response.data.data.petsDetail[0].pet_behaviour,
            container_length: response.data.data.petsDetail[0].container_length,
            relocationdetail_id:
              response.data.data.relocationdetail[0].relocationdetail_id,
            petdetail_id: response.data.data.petsDetail[0].petdetail_id,
            pet_dob: response.data.data.petsDetail[0].pet_dob,
            pet_age: response.data.data.petsDetail[0].pet_age,
            pet_weight: response.data.data.petsDetail[0].pet_weight,
          }));

          setRelocationData(response.data.data.relocationdetail[0]);

          if (
            response.data.data.paymentDetail != null &&
            response.data.data.paymentDetail != "" &&
            response.data.data.status == 3
          ) {
            setPaymentDetail(response.data.data.paymentDetail[0]);
          } else if (
            response.data.data.secpaymentDetail != null &&
            response.data.data.secpaymentDetail != ""
          ) {
            setPaymentDetail(response.data.data.secpaymentDetail[0]);
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });

      getShipmentDetail();
    }
  }, []);

  useEffect(() => {
    if (leadDetailResponse?.invoice_number) {
      setInvoiceNumber(leadDetailResponse.invoice_number);
    }
    if (leadDetailResponse?.awb_number) {
      setAwb_number(leadDetailResponse.awb_number);
    }
    if (leadDetailResponse?.relocation_date) {
      const date = new Date(leadDetailResponse.relocation_date);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const isoDateOnly = `${year}-${month}-${day}`;
      setRelocationDate(isoDateOnly);
    }

    if (leadDetailResponse?.invoice_date) {
      const date = new Date(leadDetailResponse.invoice_date);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const isoDateOnly = `${year}-${month}-${day}`;
      setInvoiceDate(isoDateOnly);
    }

  }, [leadDetailResponse]);

  function setPaymentDetail(e) {
    const paymentPercentage = (e.Token_Payment / e.Quotation) * 100;
    const Payment_Ter = paymentPercentage.toFixed(1);
    const Remaining_Payment = e.Quotation - e.Token_Payment;

    setFirstItem((prevItem) => ({
      ...prevItem,

      Quotation: e.Quotation,
      Amount_In_AED: e.Amount_In_AED,
      Payment_Ter,
      Token_Payment: e.Token_Payment,
      Remaining_Payment,
      Pymt_Status: e.Pymt_Status,
      Payment_Mode: e.Payment_Mode,
      Estimate_Id: e.Estimate_Id,
      GST: e.GST,
      amount_exc_gst: e.amount_exc_gst,
    }));
  }

  function getDeliveryType(mode) {
    if (mode != null && mode != "") {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      axios
        .get(`${baseAPI}userget/GetDeliveryType?mode_of_transport=${mode}`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          setDeliveryTypeResponse(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }



  function getCountry() {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    axios
      .get(`${baseAPI}adminget/GETCountry?countryID=0`, {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      })
      .then((response) => {
        setOriginCountryResponse(response.data.data);
        setDestinationCountryResponse(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });
  }

  function getState(country_id, type) {
    if (country_id != null && country_id != "0") {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      axios
        .get(`${baseAPI}adminget/GETState?stateID=0&countryID=` + country_id, {
          headers: {
            Authorization: "Bearer " + storedToken,
          },
        })
        .then((response) => {
          if (type === 1) {
            setOriginStateResponse(response.data.data);
          } else if (type === 2) {
            setDestinationStateResponse(response.data.data);
          }
        });
    }
  }

  function getCity(state_id, type) {
    if (state_id != null && state_id != "0") {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      axios
        .get(`${baseAPI}adminget/GETCity?cityID=0&stateID=` + state_id, {
          headers: {
            Authorization: "Bearer " + storedToken,
          },
        })
        .then((response) => {
          if (type === 1) {
            setOriginCityResponse(response.data.data);
          } else if (type === 2) {
            setDestinationCityResponse(response.data.data);
          }
        });
    }
  }

  function getPetType() {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    if (storedToken) {
      axios
        .get(`${baseAPI}adminget/GEPetType?PetType=0`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          setPetTypeResponse(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }

  function getPetBreed(pet_type) {
    if (pet_type === null || pet_type === "") {
      pet_type = 0;
    }

    const storedToken = JSON.parse(localStorage.getItem("token"));
    axios
      .get(
        `${baseAPI}adminget/GEPetBreedType?PetBreedID=0&PetType=` + pet_type,
        {
          headers: {
            Authorization: "Bearer " + storedToken,
          },
        }
      )
      .then((response) => {
        setPetBreedResponse(response.data.data);
      });
  }

  function getLeadStage(statusid) {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    axios
      .get(
        `${baseAPI}adminget/GETShipmentStages?shipment_stageId=0&shipment_statusID=` +
        statusid,
        {
          headers: {
            Authorization: "Bearer " + storedToken,
          },
        }
      )
      .then((response) => {
        if (statusid === 1) {
          setopenshipmentstageResponse(response.data.data);
        } else if (statusid === 2) {
          setcloseshipmentstageResponse(response.data.data);
        }
      });
  }

  function getLeadSubStage(stage_id) {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    axios
      .get(
        `${baseAPI}adminget/GETShipmentSubStages?shipment_stageId=` + stage_id,
        {
          headers: {
            Authorization: "Bearer " + storedToken,
          },
        }
      )
      .then((response) => {
        setSubStageResponse(response.data.data);
      });
  }

  function getShipmentDetail() {
    const searchParams = new URLSearchParams(location.search);
    const encryptedRelocationID = searchParams.get("Relocation_ID");
    const Relocation_ID = decryptRelocationID(encryptedRelocationID);

    const storedToken = JSON.parse(localStorage.getItem("token"));

    axios
      .get(
        `${baseAPI}userget/GetShipmentDetailInfo?relocation_id=` +
        Relocation_ID,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      )
      .then((response) => {
        setLeadUpdate(response.data.data);
        if (response.data.data != null && response.data.data != "") {
          setLUD(response.data.data[0]);

        }
      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });
  }

  function getEmployeeByDepartment() {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    axios
      .get(`${baseAPI}adminget/GETEmployeeByDepartment?department_id=3`, {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      })
      .then((response) => {
        setAssignToResponse(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });
  }

  function getLeadOwner(relocation_id) {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    axios
      .get(`${baseAPI}userget/GetOwnerLog?relocation_id=` + relocation_id, {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      })
      .then((response) => {
        setLeadOwnerResponse(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setshipmentDetail((prevItem) => ({
      ...prevItem,
      [name]: value,
    }));
  };

  const calculateAge = (dob) => {
    const dobDate = new Date(dob);
    const today = new Date();

    let years = today.getFullYear() - dobDate.getFullYear();
    let months = today.getMonth() - dobDate.getMonth();
    let days = today.getDate() - dobDate.getDate();

    // Adjust the calculation if the current month/day is before the birthday month/day
    if (days < 0) {
      months--;
      days += new Date(today.getFullYear(), today.getMonth(), 0).getDate(); // Get the last day of the previous month
    }

    if (months < 0) {
      years--;
      months += 12;
    }

    return `${years} years, ${months} months, ${days} days`;
  };

  const handleChangeOPenClose = (e) => {
    const { name, value } = e.target;
    setshipmentDetail((prevItem) => ({
      ...prevItem,
      [name]: value,
    }));
    getLeadSubStage(e.target.value);
    if (name === "openshipmentstage" && value !== "0") {
      setshipmentDetail((prevState) => ({
        ...prevState,
        closeshipmentstage: "0",
        sub_category: "0",
      }));
    } else if (name === "closeshipmentstage" && value !== "0") {
      setshipmentDetail((prevState) => ({
        ...prevState,
        openshipmentstage: "0",
        sub_category: "0",
      }));
    }
  };

  const handleChangeSubSTage = (e) => {
    const { name, value } = e.target;
    setshipmentDetail((prevItem) => ({
      ...prevItem,
      [name]: value,
    }));
  };

  async function setRelocationData(e) {
    setFirstItem((prevItem) => ({
      ...prevItem,
      origin_country: e.origin_country,
      origin_state: e.origin_state,
      origin_city: e.origin_city,
      origin_pin: e.origin_pin,
      destination_country: e.destination_country,
      destination_state: e.destination_state,
      destination_city: e.destination_city,
      destination_pin: e.destination_pin,
      available_slot: e.available_slot,
      mode_of_transport: e.mode_of_transport,
      origin_address: e.origin_address,
      destination_address: e.destination_address,
      origin_contact_person: e.origin_contact_person,
      destination_contact_person: e.destination_contact_person,
      origin_contact_no: e.origin_contact_no,
      destination_contact_no: e.destination_contact_no,
      origin_city_code: e.origin_city_code,
      destination_city_code: e.destination_city_code,
      delivery_type: e.delivery_type,
      distance: e.distance,
      distance2: e.distance2,
      price: e.price,
      relocation_detail: e.relocation_detail,
      sub_category: e.sub_category,
      relocation_date: e.relocation_date,
    }));

    setRelocation_date1(e.relocation_date1);
    getDeliveryType(e.mode_of_transport);

    try {
      const originCityCodeResponse = await getStationCode(
        e.origin_city,
        e.mode_of_transport
      );
      setOriginCityCodeResponse(originCityCodeResponse);

      const destinationCityCodeResponse = await getStationCode(
        e.destination_city,
        e.mode_of_transport
      );
      setDestinationCityCodeResponse(destinationCityCodeResponse);
    } catch (error) {
      // Handle errors from asynchronous calls
      console.error("Error in setRelocationData:", error);
    }
  }

  function setLUD(e) {
    setshipmentDetail((prevItem) => ({
      ...prevItem,
      nextfollowupdatetime: "",
      openshipmentstage: e.openshipmentstage,
      closeshipmentstage: e.closeshipmentstage,
      convertedstatus: e.convertedstatus,
      remark: e.remark,
      sub_category: e.sub_category,
    }));

    const stageToUse =
      e.openshipmentstage !== null &&
        e.openshipmentstage !== "0" &&
        e.openshipmentstage !== 0
        ? e.openshipmentstage
        : e.closeshipmentstage;

    if (stageToUse) {
      getLeadSubStage(stageToUse);
    }

    console.log("Close shipment stage:", e.closeshipmentstage);

  }

  const openModal = (md) => {
    setSelectedMailDetail(md);
    setIsModalOpen(true);
  };

  const closeModal = () => setIsModalOpen(false);

  function getStationCode(cityName, modeOfTransport) {
    if (cityName && modeOfTransport) {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      return axios
        .get(
          `${baseAPI}userget/GetStationCode?mode=${modeOfTransport}&station=${cityName}`,
          {
            headers: {
              Authorization: "Bearer " + storedToken,
            },
          }
        )
        .then((response) => {
          return response.data.data;
        })
        .catch((error) => {
          console.error("Error fetching station code:", error);
          throw error; // Re-throw the error if needed
        });
    }
  }

  const handleInputClick = () => {
    setIsPopupOpen(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      // Make a POST request to your API endpoint

      const response = await axios.post(
        `${baseAPI}userpost/UpdateShipmentDetail`,
        shipmentDetail, // Send shipment detail as the request body
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );
      getShipmentDetail();
      //window.location.reload();

    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  function formatDate(dateString) {
    const date = new Date(dateString);

    // Get weekday, short month, day, and year
    const datePart = new Intl.DateTimeFormat("en-US", {
      weekday: "short",
      month: "short",
      day: "numeric",
      year: "numeric",
    }).format(date);

    // Format time (12-hour format)
    const timePart = new Intl.DateTimeFormat("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    }).format(date);

    return `${datePart} | ${timePart}`;
  }




  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleUpdateClick = () => {
    const updatedData = {
      relocation_id: firstItem.relocation_id,
      relocation_date: relocationDate,
      invoice_number: invoiceNumber,
      invoice_date: invoiceDate,
      awb_number: awb_number

    };


    const storedToken = JSON.parse(localStorage.getItem("token"));
    axios.post(
      `${baseAPI}userpost/UpdateInvoiceNo`,
      updatedData,
      {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },

      }
    )
      .then((response) => {
        setSuccessMessage("Lead details updated successfully!");

        setLeadDetailResponse((prev) => ({
          ...prev,
          invoice_number: invoiceNumber,
          relocation_date: relocationDate,
          invoice_date: invoiceDate,
          awb_number: awb_number

        }));


      })
      .catch((error) => {
        console.error("Error updating lead details:", error);
        setSuccessMessage("Failed to update lead details.");
      });
    // Reset the form or perform any other actions after successful update

    setIsEditing(false);
  };


  return (
    <div>
      <div
        style={{ overflowX: "hidden" }}
        className="container-fluid container-viewLeadDetails py-0"
      >
        {/* ------------------------customer deatil--------------------- */}
        <Wrapper className="LeadDetails">
          {successMessage && (
            <div style={{ color: "green" }}>{successMessage}</div>
          )}
          <>
            <div className="viewLeadDetails-form">
              <table
                style={{
                  width: "100%",
                  color: "#6A6A6A",
                  borderRadius: "5px",
                }}
              >
                <tr className="viewLeadDetailsHeading">
                  <th
                    colSpan={4}
                    style={{
                      background: "#5B489D",
                      color: "white",
                      fontWeight: "bold",
                    }}
                  >
                    <span style={{ fontSize: "18px" }}> Customer Detail </span>
                  </th>
                </tr>
                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Full Name</span>
                  </th>
                  <td>
                    <span>{leadDetailResponse.first_name}</span>
                  </td>
                  <th>
                    <span>Email ID</span>
                  </th>
                  <td>
                    <span>{leadDetailResponse.email}</span>
                  </td>
                </tr>

                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Contact Number</span>
                  </th>
                  <td>
                    <span>{leadDetailResponse.mobile_no}</span>
                  </td>
                  <th>
                    <span>Alternative Contact Number</span>
                  </th>
                  <td>
                    <span>{leadDetailResponse.alternate_number}</span>
                  </td>
                </tr>

                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Address</span>
                  </th>
                  <td>
                    <span>{firstItem.origin_address}</span>
                  </td>
                  <th>
                    <span>City</span>
                  </th>
                  <td>
                    <span>{leadDetailResponse.origin_city1}</span>
                  </td>
                </tr>

                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>State</span>
                  </th>
                  <td>
                    <span>{leadDetailResponse.origin_state1}</span>
                  </td>
                  <th>
                    <span>PinCode</span>
                  </th>
                  <td><span>{leadDetailResponse.origin_pin}</span></td>
                </tr>
              </table>
            </div>
            <br />
            <div className="viewLeadDetails-form">
              <table
                style={{
                  width: "100%",
                  color: "#6A6A6A",
                  borderRadius: "5px",
                }}
              >
                <tr className="viewLeadDetailsHeading">
                  <th
                    colSpan={4}
                    style={{
                      background: "#5B489D",
                      color: "white",
                      fontWeight: "bold",
                    }}
                  >
                    <span style={{ fontSize: "18px" }}> Shipment Detail </span>
                  </th>
                </tr>
                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Lead Id</span>
                  </th>
                  <td>
                    <span>{leadDetailResponse.relocation_id}</span>
                  </td>
                  <th>
                    <span>Execution Date</span>
                  </th>
                  <td>
                    {isEditing ? (
                      <input
                        style={{ margin: "0px" }}
                        className="form-control"
                        type="date"
                        name="relocation_date"
                        placeholder="Please Enter*"
                        onChange={(e) => setRelocationDate(e.target.value)}
                        value={relocationDate}

                      />
                    ) : (
                      <span>
                        {new Date(
                          leadDetailResponse.relocation_date
                        ).toLocaleString("en-US", {
                          month: "short",
                          day: "numeric",
                          year: "numeric",
                        })}
                      </span>
                    )}
                  </td>
                </tr>

                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Service Type</span>
                  </th>
                  <td>
                    <span>{leadDetailResponse.servicetypename}</span>
                  </td>
                  <th>
                    <span>Lead Region</span>
                  </th>
                  <td>
                    <span>{leadDetailResponse.lead_region}</span>
                  </td>
                </tr>
                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Delivery Type</span>
                  </th>
                  <td>
                    <select
                      className="form-control"
                      name="delivery_type"
                      disabled
                      value={firstItem.delivery_type}
                    >
                      <option value="0">Select an option</option>
                      {deliveryTypeResponse.map((item) => (
                        <option value={item.delivery_type_id}>
                          {item.delivery_type_name}
                        </option>
                      ))}
                    </select>
                  </td>
                  <th>
                    <span>Payment Status</span>
                  </th>
                  <td>
                    <span
                      style={{
                        padding: "6px",
                        color: "black",
                        fontWeight: "bold",
                        textAlign: "center",
                        backgroundColor: getPaymentColor(firstItem.Pymt_Status),
                      }}
                    >
                      {firstItem.Pymt_Status}
                    </span>
                  </td>
                </tr>

                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Entry Date & Time</span>
                  </th>
                  <td>
                    <span>{leadDetailResponse.createddate}</span>
                  </td>
                  <th>
                    <span>Update Date & Time</span>
                  </th>
                  <td>
                    <span>{leadDetailResponse.modifieddate}</span>
                  </td>
                </tr>
                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Lead Owner</span>
                  </th>
                  <td>
                    <span>{leadDetailResponse.name}</span>
                  </td>
                  <th>
                    <span>Assigned To</span>
                  </th>
                  <td><span>{leadDetailResponse.assigned_to}</span></td>
                </tr>
                <tr className="viewLeadDetailsHeading">
                  <th>
                    {" "}
                    <span>Shipment Reference Number</span>
                  </th>
                  <td>                    
                    {isEditing ? (
                      <input
                        className="form-control"
                        type="text"
                        value={awb_number}
                        onChange={(e) => setAwb_number(e.target.value)}
                      />
                    ) : (
                      <span>{leadDetailResponse.awb_number}</span>
                    )}
                  </td>
                  <th>
                    <span>Ops Coordinator</span>{" "}
                  </th>
                  <td>
                    <span>{leadDetailResponse.Assigned_By_Coordinator}</span>
                  </td>
                </tr>
                <tr className="viewLeadDetailsHeading">
                  <th>{" "}
                    <span>Invoice Number</span>
                  </th>
                  <td>
                    {isEditing ? (
                      <input
                        className="form-control"
                        type="text"
                        value={invoiceNumber}
                        onChange={(e) => setInvoiceNumber(e.target.value)}
                      />
                    ) : (
                      <span>{leadDetailResponse.invoice_number}</span>
                    )}
                  </td>
                  <th>
                    <span>Invoice Date</span>
                  </th>
                  <td>
                    {isEditing ? (
                      <input
                        style={{ margin: "0px" }}
                        className="form-control"
                        type="date"
                        name="invoice_date"
                        placeholder="Please Enter*"
                        onChange={(e) => setInvoiceDate(e.target.value)}
                        value={invoiceDate}

                      />
                    ) : (
                      <span>
                        {leadDetailResponse.invoice_date
                          ? new Date(leadDetailResponse.invoice_date).toLocaleString("en-US", {
                            month: "short",
                            day: "numeric",
                            year: "numeric",
                          })
                          : ""}
                      </span>
                    )}
                  </td>
                </tr>
                <tr className="viewLeadDetailsHeading">
                  <th colSpan={4} style={{ textAlign: "right" }}>
                    {!isEditing ? (
                      <button onClick={handleEditClick} style={{ height: "36px" }}   >Edit</button>
                    ) : (
                      <button onClick={handleUpdateClick} style={{ height: "36px" }}   >Update</button>
                    )}
                  </th>
                </tr>
              </table>
            </div>
            {mailDetail.length > 0 && (
              <div className="viewLeadDetails-form">
                <table
                  style={{
                    width: "100%",
                    color: "#6A6A6A",
                    borderRadius: "5px",
                  }}
                >
                  <tr className="viewLeadDetailsHeading">
                    <th
                      colSpan={4}
                      style={{
                        background: "#5B489D",
                        color: "white",
                        fontWeight: "bold",
                      }}
                    >
                      <span style={{ fontSize: "18px" }}> Email Detail </span>
                    </th>
                  </tr>
                </table>
                <div style={{ maxHeight: "200px", overflowY: "scroll" }}>
                  <table
                    style={{
                      width: "100%",
                      color: "#6A6A6A",
                      borderRadius: "5px",
                    }}
                  >
                    <thead
                      className="viewLeadDetailsHeading"
                      style={{
                        position: "sticky",
                        top: "0",
                        zIndex: "1",
                        background: "#5B489D",
                        fontWeight: "bold",
                        fontSize: "16px",
                      }}
                    >
                      <tr>
                        <th
                          style={{
                            width: "41%",
                            padding: " 0 10px 0 13px",
                          }}
                        >
                          Subject
                        </th>
                        <th style={{ width: "10%", fontSize: "14px" }}>
                          Date & Time
                        </th>
                        <th>Sent or Receive By</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {mailDetail.map((md, index) => (
                        <tr key={index} onClick={() => openModal(md)}>
                          <td
                            style={{
                              width: "41%",
                              padding: " 0 10px 0 13px",
                            }}
                          >
                            <img
                              style={{ height: "32px", width: "32px" }}
                              src={mailIcon}
                              alt="no img"
                            />{" "}
                            <span style={{ fontSize: "13px" }}>
                              {md.subject}
                            </span>
                            <br />
                            <span
                              style={{
                                fontSize: "13px",
                                paddingLeft: "38px",
                                width: "12%",
                              }}
                            >
                              {md.fromAddress}
                            </span>
                          </td>
                          <td style={{ width: "10%", fontSize: "14px" }}>
                            {md.created_date}
                          </td>
                          <td style={{ fontSize: "13px" }}>{md.sender}</td>
                          <td>Sent</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {isModalOpen && (
                  <div
                    style={{
                      position: "fixed",
                      top: "0",
                      left: "0",
                      width: "100%",
                      height: "100%",
                      backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent black background
                      zIndex: 1000,
                    }}
                  >
                    <div
                      style={{
                        position: "fixed",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        zIndex: 1000,
                        backgroundColor: "rgba(255, 255, 255)", // Background color with opacity
                        padding: "20px",
                        borderRadius: "8px",
                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                        width: "95%", // Increase the width
                        fontSize: "16px",
                        maxWidth: "800px", // Limit maximum width
                        border: "1px solid #e0e0e0", // Add border
                      }}
                    >
                      <button
                        onClick={closeModal}
                        style={{
                          position: "absolute",
                          top: "3px",
                          right: "3px",
                          background: "none",
                          border: "none",
                          fontSize: "30px",
                          cursor: "pointer",
                          fontWeight: "bold",
                          color: "#999999",
                          width: "53px",
                        }}
                      >
                        &times;
                      </button>
                      {/* Your modal content here */}

                      <div style={{ paddingBottom: "1rem" }}>
                        <b style={{ fontSize: "20px", marginBottom: "1rem" }}>
                          {selectedMailDetail.subject}
                        </b>
                        <hr />
                        <div>
                          <div style={{ marginBottom: "0.5rem" }}>
                            <span style={{ fontWeight: "bold" }}>From:</span>{" "}
                            <span>{selectedMailDetail.sender}</span>{" "}
                            <span style={{ marginLeft: "1rem" }}>
                              {selectedMailDetail.fromAddress}
                            </span>
                          </div>

                          <div>
                            <span style={{ fontWeight: "bold" }}>To:</span>{" "}
                            <span>{selectedMailDetail.toAddress}</span>
                          </div>
                        </div>
                        <hr />
                        <div
                          style={{
                            maxHeight: "300px",
                            paddingTop: "1rem",
                            fontSize: "16px",
                            overflowY: "auto",
                          }}
                        >
                          {/*--------------Add your email body here*/}
                          <p>{selectedMailDetail.summary}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}

            <br />

            {/* --------------------------Relocation Details View---------------------------------------- */}

            <div className="viewLeadDetails-form">
              <table
                style={{
                  width: "100%",
                  color: "#6A6A6A",
                  borderRadius: "5px",
                }}
              >
                <tr className="viewLeadDetailsHeading">
                  <th
                    colSpan={4}
                    style={{
                      background: "#5B489D",
                      color: "white",
                      fontWeight: "bold",
                    }}
                  >
                    <span style={{ fontSize: "18px" }}>
                      {" "}
                      Relocation Detail{" "}
                    </span>
                  </th>
                </tr>
                <tr
                  className="viewLeadDetailsHeading"
                  style={{ height: "3px" }}
                >
                  <td
                    colSpan={4}
                    style={{
                      background: "#ffffff",
                    }}
                  ></td>
                </tr>
                <tr className="viewLeadDetailsHeading">
                  <th
                    colSpan={2}
                    style={{
                      background: "#A3519F",
                      color: "white",
                      fontWeight: "bold",
                      textAlign: "center",
                    }}
                  >
                    <span style={{ fontSize: "16px" }}> From </span>
                  </th>

                  <th
                    colSpan={2}
                    style={{
                      background: "#A3519F",
                      color: "white",
                      fontWeight: "bold",
                      textAlign: "center",
                    }}
                  >
                    <span style={{ fontSize: "16px" }}> To </span>
                  </th>
                </tr>

                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Origin Location</span>
                  </th>
                  <td>
                    <span>{`${leadDetailResponse.origin_city1} , ${leadDetailResponse.origin_state1} , ${leadDetailResponse.origin_country1}`}</span>
                  </td>
                  <th>
                    <span>Destination Location</span>
                  </th>
                  <td>
                    <span>{`${leadDetailResponse.destination_city1} , ${leadDetailResponse.destination_state1} , ${leadDetailResponse.destination_country1}`}</span>
                  </td>
                </tr>

                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Pickup Address</span>
                  </th>
                  <td>
                    <span> {firstItem.origin_address} </span>
                  </td>
                  <th>
                    <span>Drop Address</span>
                  </th>
                  <td>
                    <span>{firstItem.destination_address} </span>
                  </td>
                </tr>

                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Origin Pincode</span>
                  </th>
                  <td>
                    <span>{leadDetailResponse.origin_pin}</span>
                  </td>
                  <th>
                    <span>Destination Pincode</span>
                  </th>
                  <td>
                    <span>{leadDetailResponse.destination_pin}</span>
                  </td>
                </tr>

                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Sender's Name</span>
                  </th>
                  <td>{firstItem.origin_contact_person}</td>
                  <th>
                    <span>Receiver's Name</span>
                  </th>
                  <td>{firstItem.destination_contact_person}</td>
                </tr>

                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Sender's Contact</span>
                  </th>
                  <td>{firstItem.origin_contact_no}</td>
                  <th>
                    <span>Receiver's Contact</span>
                  </th>
                  <td>{firstItem.destination_contact_no}</td>
                </tr>

                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Sender's Alternate Contact</span>
                  </th>
                  <td>{firstItem.origin_contact_no}</td>
                  <th>
                    <span>Receiver's Alternate Contact</span>
                  </th>
                  <td>{firstItem.destination_contact_no}</td>
                </tr>

                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Sender’s Email Id</span>
                  </th>
                  <td>{firstItem.origin_contact_no}</td>
                  <th>
                    <span>Receiver's Email Id</span>
                  </th>
                  <td>{firstItem.destination_contact_no}</td>
                </tr>
              </table>
            </div>

            <div className="viewLeadDetails-form">
              <table
                style={{
                  width: "100%",
                  color: "#6A6A6A",
                  borderRadius: "5px",
                }}
              >
                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Pick-up Distance</span>
                  </th>
                  <td>
                    <span></span>
                  </td>
                  <th>
                    <span>Drop Distance</span>
                  </th>
                  <td>
                    <span></span>
                  </td>
                </tr>

                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Relocation Stage</span>
                  </th>
                  <td>
                    <span></span>
                  </td>
                  <th>
                    <span>Status</span>
                  </th>
                  <td>
                    <span></span>
                  </td>
                </tr>

                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Selected Slot</span>
                  </th>
                  <td>
                    <span></span>
                  </td>
                  <th>
                    <span>Mode of Transportation</span>
                  </th>
                  <td>
                    <span></span>
                  </td>
                </tr>

                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>From Airport</span>
                  </th>
                  <td></td>
                  <th>
                    <span>To Airport</span>
                  </th>
                  <td></td>
                </tr>

                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Airline Name</span>
                  </th>
                  <td></td>
                  <th>
                    <span>Flight Number</span>
                  </th>
                  <td></td>
                </tr>

                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Departure Time (Estimate)</span>
                  </th>
                  <td></td>
                  <th>
                    <span>Arrival Time (Estimate)</span>
                  </th>
                  <td></td>
                </tr>
              </table>
            </div>

            {/* ------------------------------------------------------------------------------------------------ */}
            <br />
            <br />
            {/* --------------------------Pet Details View---------------------------------------- */}

            {petDetail.map((pet, index) => (
              <div className="viewLeadDetails-form">
                <table
                  style={{
                    width: "100%",
                    color: "#6A6A6A",
                    borderRadius: "5px",
                  }}
                >
                  <tr className="viewLeadDetailsHeading">
                    <th
                      colSpan={4}
                      style={{
                        background: "#5B489D",
                        color: "white",
                        fontWeight: "bold",
                      }}
                    >
                      <span style={{ fontSize: "16px" }}> Pet Detail </span>
                    </th>
                  </tr>

                  <tr className="viewLeadDetailsHeading">
                    <th>
                      <span>Number of Pets</span>
                    </th>
                    <td>
                      <span>{leadDetailResponse.number_of_pets}</span>
                    </td>
                    <th>
                      <span>Pet Type & Breed</span>
                    </th>
                    <td>
                      <span>{`${pet.pettype} , ${pet.petbreedtype}`}</span>
                    </td>
                  </tr>
                  <tr className="viewLeadDetailsHeading">
                    <th>
                      <span>Pet Name</span>
                    </th>
                    <td>
                      <span>{pet.pet_name}</span>
                    </td>

                    <th>
                      <span>Pet Gender</span>
                    </th>
                    <td>
                      <span>{pet.pet_gender}</span>
                    </td>
                  </tr>

                  <tr className="viewLeadDetailsHeading">
                    <th>
                      <span>Pet DOB | Pet Age</span>
                    </th>
                    <td>
                      <span>
                        {" "}
                        {pet.pet_dob}{" "}
                        {pet.pet_dob && `(${calculateAge(pet.pet_dob)})`}
                      </span>
                    </td>

                    <th>
                      <span>Pet Weight</span>
                    </th>
                    <td>
                      <span>{pet.pet_weight}</span>
                    </td>
                  </tr>

                  <tr className="viewLeadDetailsHeading">
                    <th>
                      <span>Pet Behaviour</span>
                    </th>
                    <td>
                      <span>{pet.pet_behaviour}</span>
                    </td>

                    <th>
                      <span>Pet Colour</span>
                    </th>
                    <td>
                      <span>{pet.pet_color}</span>
                    </td>
                  </tr>

                  <tr className="viewLeadDetailsHeading">
                    <th>
                      <span>Pet Measurement (A,B,C&D)</span>
                    </th>
                    <td>
                      <span>{`${pet.pet_length} , ${pet.container_length} , ${pet.pet_width} , ${pet.pet_height} , `}</span>
                    </td>
                    <th></th>
                    <td></td>
                  </tr>
                </table>
              </div>
            ))}

            {/* ----------------------------Pet images View------------------------------------------------ */}
            <br />
            <br />

            <div className="viewLeadDetails-form">
              <table
                style={{
                  width: "100%",
                  color: "#6A6A6A",
                  borderRadius: "5px",
                }}
              >
                <tr className="viewLeadDetailsHeading">
                  <th
                    colSpan={2}
                    style={{
                      background: "#5B489D",
                      color: "white",
                      fontWeight: "bold",
                    }}
                  >
                    <span style={{ fontSize: "16px" }}>
                      {" "}
                      Pet related Pictures{" "}
                    </span>
                  </th>
                </tr>
                <tr
                  className="viewLeadDetailsHeading"
                  style={{ height: "20px" }}
                >
                  <th
                    colSpan={2}
                    style={{
                      background: "#FFFFFF",
                    }}
                  ></th>
                </tr>
                <tr>
                  <td style={{ width: "50%" }}>
                    <div
                      style={{
                        border: "1px solid #DEE2E6",
                        borderRadius: "1rem",
                      }}
                    >
                      <div
                        style={{ marginTop: "-1px", width: "36%" }}
                        className="pet-image-text-1"
                      >
                        <h4>Vaccination Book</h4>
                      </div>
                      <table style={{ width: "100%" }}>
                        <tr>
                          <td style={{ height: "11rem", width: "50%" }}>
                            {firstItem.vaccinationbook_front &&
                              firstItem.vaccinationbook_front.trim() !== "" ? (
                              <img
                                alt="vaccination Book Front"
                                src={vaccinationBookFront}
                                style={{
                                  width: "100%",
                                  height: "11rem",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  handleImageClick(vaccinationBookFront)
                                }
                              />
                            ) : (
                              <img
                                alt="Not Found"
                                src={images2}
                                style={{
                                  width: "100%",
                                  height: "11rem",
                                  opacity: "0.1",
                                }}
                              />
                            )}
                          </td>
                          <td style={{ height: "11rem", width: "50%" }}>
                            {firstItem.vaccinationbook_back &&
                              firstItem.vaccinationbook_back.trim() !== "" ? (
                              <img
                                alt="vaccination Book Back"
                                src={vaccinationBookBack}
                                style={{
                                  width: "100%",
                                  height: "11rem",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  handleImageClick(vaccinationBookBack)
                                }
                              />
                            ) : (
                              <img
                                alt="Not Found"
                                src={images2}
                                style={{
                                  width: "100%",
                                  height: "11rem",
                                  opacity: "0.1",
                                }}
                              />
                            )}
                          </td>
                        </tr>
                      </table>
                    </div>
                  </td>
                  <td style={{ width: "50%" }}>
                    <div
                      style={{
                        border: "1px solid #DEE2E6",
                        borderRadius: "1rem",
                      }}
                    >
                      <h4
                        style={{ marginTop: "-1px", width: "36%" }}
                        className="pet-image-text-2"
                      >
                        Pet Photos
                      </h4>
                      <table style={{ width: "100%" }}>
                        <tr>
                          <td style={{ height: "11rem", width: "50%" }}>
                            {firstItem.pet_photo_standing &&
                              firstItem.pet_photo_standing.trim() !== "" ? (
                              <img
                                alt="pet Photos Standing"
                                src={petPhotosStanding}
                                style={{
                                  width: "100%",
                                  height: "11rem",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  handleImageClick(petPhotosStanding)
                                }
                              />
                            ) : (
                              <img
                                alt="Not Found"
                                src={images2}
                                style={{
                                  width: "100%",
                                  height: "11rem",
                                  opacity: "0.1",
                                }}
                              />
                            )}
                          </td>
                          <td style={{ height: "11rem", width: "50%" }}>
                            {firstItem.pet_photo_sitting &&
                              firstItem.pet_photo_sitting.trim() !== "" ? (
                              <img
                                alt="pet Photos Sitting"
                                src={petPhotosSitting}
                                style={{
                                  width: "100%",
                                  height: "11rem",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  handleImageClick(petPhotosSitting)
                                }
                              />
                            ) : (
                              <img
                                alt="Not Found"
                                src={images2}
                                style={{
                                  width: "100%",
                                  height: "11rem",
                                  opacity: "0.1",
                                }}
                              />
                            )}
                          </td>
                        </tr>
                      </table>
                    </div>
                  </td>
                </tr>
              </table>

              {showModal && (
                <div className="modal" onClick={handleCloseModal}>
                  <span className="close" onClick={handleCloseModal}>
                    &times;
                  </span>
                  <img
                    className="modal-content"
                    src={selectedImage}
                    alt="Full Screen"
                  />
                </div>
              )}
            </div>
            <br />
            <br />
          </>
        </Wrapper>

        <br />
        <br />

        <Wrapper className="LeadDetails">
          {/* ----------------------------------Update Shipment Information-------------------------------------- */}

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-end",
            }}
          >
            <div className="viewLeadDetails-form">
              <table
                style={{
                  width: "100%",
                  color: "#6A6A6A",
                  borderRadius: "5px",
                }}
              >
                <tr>
                  <td colSpan={4}>
                    <table style={{ width: "100%" }}>
                      <tr className="viewLeadDetailsHeading">
                        <th
                          style={{
                            background: "#5B489D",
                            color: "white",
                            fontWeight: "bold",
                            width: "87%",
                            borderRight: "1px solid white",
                            borderTopRightRadius: "1px",
                            borderBottomRightRadius: "1px",
                          }}
                        >
                          <span style={{ fontSize: "18px" }}>
                            {" "}
                            Update Shipment Information{" "}
                          </span>
                        </th>

                        <th
                          style={{
                            background: "#5B489D",
                            color: "white",
                            fontWeight: "bold",
                            width: "12%",
                            borderLeft: "1px solid white",
                            borderTopLeftRadius: "1px",
                            borderBottomLeftRadius: "1px",
                          }}
                        >
                          <span>Total Remarks - {leadUpdate.length}</span>
                        </th>
                      </tr>
                    </table>
                  </td>
                </tr>
                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Next Follow-up Date/Time</span>
                  </th>
                  <td>
                    <input
                      className="form-control"
                      type="datetime-local"
                      name="shipment_nextFollowUpDate"
                      value={shipmentDetail.shipment_nextFollowUpDate}
                      placeholder="Please Enter*"
                      onChange={handleChange}
                    />
                  </td>
                  <th>
                    <span>Open Shipment Stage</span>
                  </th>
                  <td>
                    <select
                      className="form-control"
                      name="openshipmentstage"
                      value={shipmentDetail.openshipmentstage?.toString() || "0"}
                      onChange={handleChangeOPenClose}
                    // disabled={isDisabled}
                    >
                      <option value="0">Select an option</option>
                      {openshipmentstageResponse !== null ? (
                        openshipmentstageResponse.map((item) => (
                          <option value={item.shipment_stageId.toString()} key={item.shipment_stageId}  >
                            {item.shipment_stageName}
                          </option>
                        ))
                      ) : (
                        <p>empty</p>
                      )}
                    </select>
                  </td>
                </tr>

                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Close Shipment Stage</span>
                  </th>
                  <td>
                    <select
                      className="form-control"
                      name="closeshipmentstage"
                      value={shipmentDetail.closeshipmentstage?.toString() || "0"}
                      onChange={handleChangeOPenClose}
                    // disabled={isDisabled}
                    >
                      <option value="0">Select an option</option>
                      {closeshipmentstageResponse !== null ? (
                        closeshipmentstageResponse.map((item) => (
                          <option value={item.shipment_stageId} key={item.shipment_stageId} >
                            {item.shipment_stageName}
                          </option>
                        ))
                      ) : (
                        <p>empty</p>
                      )}
                    </select>
                  </td>

                  <th>
                    <span>Sub Category</span>
                  </th>
                  <td>
                    <select
                      className="form-control"
                      type="text"
                      name="sub_category"
                      value={shipmentDetail.sub_category || "0"}
                      placeholder="Please Enter*"
                      onChange={handleChange}
                    // disabled={isDisabled}
                    >
                      <option value="0">Select an option</option>
                      {subStageResponse !== null ? (
                        subStageResponse.map((item) => (
                          <option value={item.shipment_substageId.toString()} key={item.shipment_substageId} >
                            {item.shipment_substageName}
                          </option>
                        ))
                      ) : (
                        <p>empty</p>
                      )}
                    </select>
                  </td>
                </tr>

                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Executed Status</span>
                  </th>
                  <td>
                    <select
                      className="form-control"
                      type="text"
                      name="Status"
                      value={orderDetail.Status}
                      disabled={isDisabled}                    >
                      <option value="0">Untouched</option>
                      <option value="1">Open</option>
                      <option value="2">Executed</option>
                      <option value="3">Cancelled</option>
                    </select>
                  </td>
                  <th>
                    <span></span>
                  </th>
                  <td></td>
                </tr>

                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Remark</span>
                  </th>
                  <td colSpan={3}>
                    <div
                      className="row"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        height: "70px",
                      }}
                    >
                      <div className="col-10">
                        <input
                          // className="form-control"
                          type="text"
                          name="remark"
                          value={shipmentDetail.remark}
                          onChange={handleChange}
                          style={{ width: "100%", height: "32px" }}
                        />
                      </div>
                      <div className="col-2">
                        <button
                          style={{
                            backgroundColor: "#5B489D",
                            color: "white",
                            width: "93%",
                            // margin: "7px",
                          }}
                          className="btn btn-success inputDoc3"
                          onClick={handleSubmit}
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <br />
          <h3
            style={{
              marginTop: "1rem",
              fontSize: "16px",
              fontWeight: "bold",
            }}
          >
            {" "}
            Remark Timeline
          </h3>
          <div
            style={{
              width: "100%",
              maxHeight: "300px",
              overflowY: "scroll",
              alignItems: "center",
            }}
          >
            <table
              className="customerDetailsTable"
              style={{ width: "99%", marginLeft: "5px" }}
            >
              {leadUpdate.map((remark, index) => (
                <div className="wrapper undefined" style={{ width: "100%" }}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      margin: "1rem",
                      padding: "1rem",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <h3 className="card-title">
                        <b>Remark {leadUpdate.length - index} </b>{" "}
                      </h3>
                      <p className="card-text">
                        {" "}
                        <b> {formatDate(remark.createdDate)} </b>{" "}
                      </p>
                    </div>
                    <div className="row" style={{ padding: "11px 0 0 0" }}>
                      <div className="col-4">
                        <div className="card" style={{ width: "100%" }}>
                          <div className="card-body">
                            <p className="card-text">
                              <b>Shipment Stage</b>
                              {remark.openshipmentstage_name !== null && (
                                <span>
                                  (Open) - {remark.openshipmentstage_name}
                                </span>
                              )}
                              {remark.closedshipmentstage_name !== null && (
                                <span>
                                  (Close) - {remark.closedshipmentstage_name}
                                </span>
                              )}
                              <span style={{ fontWeight: "bold" }}>
                                - {remark.shipment_substageName}
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="col-4">
                        <div className="card" style={{ width: "100%" }}>
                          <div className="card-body">
                            <p className="card-text">
                              <b>- </b>
                              {/* <span>{remark.assignto}</span> */}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="col-4">
                        <div className="card" style={{ width: "100%" }}>
                          <div className="card-body">
                            <p className="card-text">
                              <b>Next Follow Up Date/Time - </b>
                              <span>{remark.shipment_nextFollowUpDate}</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="row"
                      style={{ padding: "11px 0 0 0", border: "none" }}
                    >
                      <div className="col-12">
                        <div
                          className="card"
                          style={{
                            width: "100%",
                            boeder: "none",
                            background: "none",
                          }}
                        >
                          <div className="card-body">
                            <p
                              className="card-text"
                              style={{
                                fontSize: "14px",
                                fontWeight: "bold",
                              }}
                            >
                              {remark.remark}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </table>
          </div>
        </Wrapper>
      </div>
    </div>
  );
};

export default ShipmentDetail;
